<template>
  <t-form
    :class="{ 'form_select_conciseMode': option.attribute.conciseMode, 'form_select-combination-hide': option.attribute.isCombinationPageShow, 'form_select-combination-show': option.attribute.isCombinationPageShow && showCurrent }"
    @mouseover="mouseEnter" @mouseout="mouseOut" :requiredMark="option.attribute.required"
    :labelAlign="option.attribute.labelAlign" :style="setStyles">
    <t-form-item :label="option.attribute.label"
      :class="{ 'my_select': true, 'my_select_conciseMode': option.attribute.conciseMode }" :style="setStyles">
      <t-select :autoWidth="option.attribute.conciseMode" :options="options" v-model="checkedVal" class="my_select_item"
        :style="setStyles" :placeholder="option.attribute.placeholder" @change="clickHandler"
        @popupVisibleChange="onPopupVisibleChange" :multiple="option.attribute.multiple" :status="message" :tips="tips"
        clearable :filterable="option.attribute.filterable" :showArrow="option.attribute.timeIcon" :popupProps='{
          overlayClassName, overlayStyle: setStyles,
          placement: ((option.attribute.conciseMode && option.attribute.conciseMode_position) || "bottom"),
          visible: popupShow
        }' @InputChange="InputChange" @blur="onBlur" @focus="onFocus" />
    </t-form-item>
  </t-form>
</template>

<script>
import { mapActions, mapState } from 'pinia'
import { useCombinationPageStore } from '@/stores/combinationPageStore'
import { getDataJson, pollingRefresh, getDefaultValue, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";
// import { mixinsCom } from "@/mixins/globalAllComps";
import { fileUrl } from '/env'
import option from "../echarts/attrs/cpt-chart-candlestick-line-option";
export default {
  name: "cpt-select",
  props: {
    option: Object,
    components: Array,
    current: Object,
    refMap: Object,
  },
  // mixins: [mixinsCom], 
  data() {
    return {
      options: [],
      uuid: null,
      checkedVal: null,
      newData: "",
      jsFunFlag: false,
      message: "default",
      tips: "",
      fileUrl,
      popupShow: false
    }
  },
  watch: {
    // 'option.attribute': {
    //   handler(obj) {
    //     this.processData(this.option.cptDataForm, this.newData, this.jsFunFlag);
    //   },
    //   deep: true,
    // },
    "current.cptShow"(val) {
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },

  },
  mounted() {


    this.combinationTabPage()


    //编辑界面需要展示所有组合控件 ，但是预览界面需要初始隐藏
    // if(this.current.id == 'dc962330-39dc-11ef-b26c-095863707c01'){
    //   console.log(this.current,'453tt5g43')
    //   this.current.cptOption.interaction.eventList[0].dataArr[4] = {
    //     arr: [],
    //     id: "eb398500-3453-11ef-97ed-5f44e4537360",
    //     title: "iframe"
    //   }
    //   this.current.cptOption.interaction.eventList[0].linkageData[4] = 'eb398500-3453-11ef-97ed-5f44e4537360'
    //   console.log( this.current.cptOption.interaction.eventList,'453tt5g43')
    // }
    if (this.$route.name != "design") {
      //  console.log(this.components,'components')
      // 默认要组合控件，但是初始化的时候，需要先隐藏，所以需要更改组合控件的属性
      this.components.forEach((component) => {
        let item = component.cptOption.attribute.typeInputSearch;
        if (item && component.typeInputSearch !== '' && component.cptKey !== 'cpt-select' && (component.cptKey !== 'cpt-button' || component.cptOption.attribute.buttonGroupType != '1')) {
          // component.cptShow = false;
        }
      })
    }
  },
  created() {
    this.uuid = require('uuid').v1();
    console.log('123123')
    this.setPageData(this.option.attribute.combinationCompId, 1, false)


    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    // console.log(this.option.attribute,'this.option.attribute')
    if (!this.option.attribute.noQuery || this.dataReload.includes(0)) {
      this.refreshCptData();
    }

    // 后期添加的 filterable，兼容旧数据
    if (!this.option.attribute.hasOwnProperty('filterable')) {
      console.log(';0000')
      this.option.attribute.filterable = true
    }
    if (!this.option.cptDataForm.hasOwnProperty('isCache')) {
      this.option.cptDataForm['isCache'] = false
    }
  },
  computed: {
    // cptData() {  //组件绑定的属性
    //   console.log("======textres====",this.option.cptDataForm.resData);
    //   if(this.option.cptDataForm.resData){
    //       return this.processData(this.option.cptDataForm, this.option.cptDataForm.resData);
    //   }
    // },

    // iptVal: {  //组件绑定的属性
    //   get() {
    //     if(this.option.cptDataForm.resData){
    //         return this.processData(this.option.cptDataForm, this.option.cptDataForm.resData);
    //     }
    //   },
    //   set(newValue) {
    //     this.option.cptDataForm.resData = {value:newValue,options:this.options}
    //   }
    // },
    overlayClassName() {
      return { 'my_select_popup': true, 'my_select_popup_concise': this.option.attribute.conciseMode }
    },
    setStyles() {
      return {
        // "--labelWidth":this.option.attribute.labelWidth + "px",
        "--width": this.option.attribute.width + "px",
        "--height": this.option.attribute.height + "px",
        "--indent": this.option.attribute.indent + "px",
        "--bgColor": this.option.attribute.bgColor,
        "--textColor": this.option.attribute.textColor,
        "--placholderColor": this.option.attribute.textPlaceholderColor,
        "--fontStyle": this.option.attribute.fontStyle,
        "--fontWeight": this.option.attribute.fontWeight,
        "--fontFamily": this.option.attribute.fontFamily,
        "--fontSize": this.option.attribute.fontSize + "px",
        "--borderSize": this.option.attribute.borderSize + "px",
        "--borderColor": this.option.attribute.borderColor,
        "--borderRadius": this.option.attribute.borderRadius + "px",
        "--lineType": this.option.attribute.lineType,
        "--align": this.option.attribute.align,
        "--disableColor": this.option.attribute.disableColor,
        "--activeBgColor": this.option.attribute.activeBgColor,
        "--marginLeft": this.option.attribute.labelBoolean && this.option.attribute.labelAlign != 'top' ? this.option.attribute.labelWidth + "px" : '0px',
        "--labelWidth": this.option.attribute.labelWidth + "px",
        "--labelBoolean": this.option.attribute.labelBoolean ? 'block' : 'none',
        '--optionBg': this.option.attribute.optionBg,
        '--optionColor': this.option.attribute.optionColor,
        '--optionFontSize': this.option.attribute.optionFontSize + 'px',
        '--optionSelectedBg': this.option.attribute.optionSelectedBg,
        '--optionSelectedColor': this.option.attribute.optionSelectedColor,
        '--conciseMode_image': `url(${fileUrl + this.option.attribute.conciseMode_image})`,
        // '--conciseImageWidth': (this.option.attribute.conciseImageWidth || 40) + 'px',
        // '--conciseImageHeight': (this.option.attribute.conciseImageHeight || 40) + 'px',
      };
    },
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
    ...mapState(useCombinationPageStore, {
      showCurrent(store) {
        return store.pageData[this.option.attribute.combinationCompId].includes(true)
      }
    })
  },
  methods: {
    ...mapActions(useCombinationPageStore, ['setPageData']),

    refreshCptData(cptDataForm = this.option.cptDataForm, paras) {
      pollingRefresh(this.uuid, cptDataForm, () => {
        this.loadData(cptDataForm, paras)
      }, this.components)
    },
    loadData(cptDataForm, paras) {
      const that = this;
      getDataJson(cptDataForm, paras, (res) => {
        that.newData = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
        // that.jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
        that.processData(cptDataForm, that.newData, that.jsFunFlag)    //监听里面会执行的
        // console.log(that.jsFunFlag)
      },)
    },
    processData(cptDataForm, res, jsFunFlag, isFromGrid) {
      console.log(cptDataForm, 'processData222222')
      // 第一层判断 如果选择数据集
      if (cptDataForm.dataSource == '4') {
        // if (this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid') return

        // console.log(res, 'res')
        // 第二层判断 ，如果没有配转换脚本
        // if (jsFunFlag) { // 没有全部配置映射字段
        //判断此控件在九宫格里面就不请求数据
        if (hasNonEmptyValues(this.option.attribute.cptTableData)) {
          const dataKey = this.option.attribute.cptTableData;
          // 创建一个新的数组用于存储结果
          let newres = [];
          if (!Array.isArray(res) && res.options) {
            // 遍历one数组，根据two数组中的映射关系生成新对象并添加到newOptions中
            res.options.forEach(item => {
              let newItem = {};
              dataKey.forEach(mapping => {
                newItem[mapping.namekey] = item[mapping.value];
              });
              // 合并原有的键值对
              Object.assign(newItem, item);
              newres.push(newItem);
            });

          } else {
            // 遍历one数组，根据two数组中的映射关系生成新对象并添加到newOptions中
            res.forEach(item => {
              let newItem = {};
              dataKey.forEach(mapping => {
                newItem[mapping.namekey] = item[mapping.value];
              });
              // 合并原有的键值对
              Object.assign(newItem, item);
              newres.push(newItem);
            });
          }


          let newObject = {
            value: [],
            options: newres
          };
          // this.newData = newObject;

          if (newObject) {
            this.funselect(newObject);
          }

        }
        // } else { // 如果配置了转换脚本
        //   if (res) {
        //     this.funselect(res);
        //   }
        // }
      } else { // 不是数据集类型，是静态数据
        let otherData = res && res.hasOwnProperty('value') && res.hasOwnProperty('options')
        console.log(otherData, 'otherDataotherData');
        this.funselect(otherData ? res : this.newData);
      }
    },
    funselect(res) {
      console.log(res, 'asijdiadiaijadiaj');
      if (res.options) {
        this.options = res.options;
      }
      console.log(this.current,'this.currentCpt.cptKeythis.currentCpt.cptKeythis.currentCpt.cptKey');
      const defaultValue = getDefaultValue(this.option.attribute, this.current.cptKey, this.options)

      // console.log(res.options,'res.options')
      console.log(res.options, 'res.options');
      let isDefaultValue = res.options?.find(({ value }) => value == defaultValue)
      console.log(isDefaultValue, defaultValue, 'adijasijdiasjidis');
      if (isDefaultValue) {
        this.checkedVal = isDefaultValue.value
      } else {
        // 原有代码
        // this.checkedVal = res

        // 兼容下面 强制赋值 
        this.checkedVal = res.value || res.options[0].value;
      }
      console.log(this.checkedVal, 'qwdijiqwjdiqwdjidjiwqdqijw');
      this.clickHandler(this.checkedVal)

      // 强制赋值options第一个
      // if(res.value !== undefined && res.value !== '' && this.current.id !== '3f74ad70-11c7-11ef-be9f-873c49539d87'){
      // if (res.value !== undefined && res.value !== '') {
      //   // console.log(this.checkedVal,res.value,'this.checkedValthis.checkedVal')
      //   if (res.options.length) {
      //     this.checkedVal = res.options[0].value
      //     // this.clickHandler(this.checkedVal)
      //   }
      //   this.clickHandler(this.checkedVal)
      // }


      if (this.current.id == '3f74ad70-11c7-11ef-be9f-873c49539d87') {
        console.log(res, 'this.current.id')
        this.checkedVal = res.options[0]?.value;
        setTimeout(() => {
          this.clickHandler(this.checkedVal)
        }, 300)

      }


    },
    clickHandler(val) {
      console.log(val, 'asdijasidjiasdaidsajidi');
      setTimeout(() => {
        // this.onTabChange()
        this.$emit("clickHandler", this.option.interaction, val, val, 'cpt-select', val, this.current)
      }, 300)
      this.checkValue();
      //文本搜索控件组合了下拉框，要写一些定制化代码，例如显示隐藏
      // if (this.$route.name != "design"){
      //   if (Array.isArray(this.current.group) && this.current.group.length > 0) {
      //     console.log('change')
      //       this.showHideMethod(val);
      //   }
      // }
    },
    combinationTabPage() {
      console.log(this.option.attribute, 'qwdjiqwidiqwjiijqdwijod');
      let tab = this.option.interaction.eventList.find(item => item.intType == "combinationTabPage")
      if (!tab) {
        return
      }
      window.addEventListener('message', message => {
        console.log(message, 'adijasidaiosjdiojdsjio');
        if (message.data.type === "TABCHANGEMESSAGE") {
          let data = JSON.parse(message.data.data)
          this.checkedVal = data.activeKey
        }
      })
    },
    // onTabChange() {
    //   let event = this.option.interaction.eventList.find(e => e.intType == 'combinationTabPage')
    //   if (!event) {
    //     return
    //   }
    //   let tabId = event.tabId
    //   if (tabId) {
    //     console.log(this.refMap[tabId], tabId, this.refMap, 'tab');
    //     console.log(this.options, this.newData, 'asdiohjasiojidoio');
    //     let index = this.options.findIndex(item => item.value == this.newData.value)
    //     this.refMap[tabId].changeTab(this.newData.value, index)
    //     // changeTab 
    //   }
    // },
    // 校验方法
    checkValue() {
      const { attribute } = this.option;
      if (attribute.required && !this.checkedVal) {
        this.setValidationMessage(false);
        return false;
      } else {
        this.setValidationMessage(true);
        return true;
      }
    },
    setValidationMessage(isValid) {
      this.message = isValid ? "default" : "error";
      this.tips = isValid ? "" : `${this.option.attribute.label}必选`;
    },
    setValue(value) {
      this.checkedVal = value
    },
    getValue() {
      return this.checkedVal
    },
    InputChange(val) {
      //文本搜索控件组合了下拉框，要写一些定制化代码，例如显示隐藏
      // if (this.$route.name != "design"){
      //   if (Array.isArray(this.current.group) && this.current.group.length > 0) {
      //     console.log('input')
      //     this.showHideMethod(val);
      //   }
      // }
    },
    showHideMethod(val) {
      console.log(val, 'val')
      if (val != '') {
        if (Array.isArray(this.components) && this.components.length > 0) {
          this.components.forEach(item => {
            if (this.current.group.includes(item.id) && item.cptKey === 'cpt-text') {
              item.cptShow = false;
            }
            if (this.current.group.includes(item.id) && item.cptOption.attribute.buttonGroupType == 3 && item.cptKey === 'cpt-button') {
              item.cptShow = false;
            }
            if (this.current.group.includes(item.id) && item.cptKey === 'cpt-radio') {
              item.cptShow = false;
            }
          });
        }
      } else {
        if (Array.isArray(this.components) && this.components.length > 0) {
          this.components.forEach(item => {
            if (this.current.group.includes(item.id) && item.cptKey === 'cpt-text') {
              item.cptShow = true;
            }
            if (this.current.group.includes(item.id) && item.cptOption.attribute.buttonGroupType == 3 && item.cptKey === 'cpt-button') {
              item.cptShow = true;
            }
            if (this.current.group.includes(item.id) && item.cptKey === 'cpt-radio') {
              item.cptShow = true;
            }
          });
        }
      }
    },

    mouseEnter() {

      this.setPageData(this.option.attribute.combinationCompId, 1, true)
    },
    onBlur() {

      this.popupShow = false
    },
    onFocus() {
      this.popupShow = true
    },
    // 关联组件显示隐藏
    mouseOut() {
      if (!this.popupShow) {
        this.setPageData(this.option.attribute.combinationCompId, 1, false)
      }
    },
    onPopupVisibleChange(flag) {
      console.log(flag, this.option.attribute.isCombinationPageShow, 'qwdi9jqwijdqiwo9djqwij9odqwji0odqjwido0w');

      this.popupShow = flag
      if (!this.option.attribute.isCombinationPageShow) {
        return false
      }

      if (flag == false) {
        this.setPageData(this.option.attribute.combinationCompId, 1, false)
      }
    }
  },
}
</script>
<style>
.my_select_popup .t-select-option {
  background: var(--optionBg);
  color: var(--optionColor);
}

.my_select_popup .t-select-option span {
  font-size: var(--optionFontSize);
  font-family: var(--fontFamily);
}

.my_select_popup .t-is-selected {
  background: var(--optionSelectedBg) !important;
  color: var(--optionSelectedColor) !important;
  font-family: var(--fontFamily);
}

.my_select .t-form__label label {
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
  line-height: var(--height);
  display: var(--labelBoolean);
  /* width: var(--labelWidth) !important; */
}

.t-form .my_select .t-form__controls {
  margin-left: 0px !important;
}

.my_select_item .t-input .t-input__inner::placeholder {
  color: var(--placholderColor);
}

/* 简洁模式 */
.my_select_conciseMode .t-form__label {
  display: none;
}

.my_select_conciseMode,
.form_select_conciseMode,
.my_select_conciseMode .t-select,
.my_select_conciseMode .t-input__wrap,
.my_select_conciseMode .t-form__controls,
.my_select_conciseMode .my_select_item,
.my_select_conciseMode .t-form__controls-content,
.my_select_conciseMode .t-input,
.my_select_conciseMode .t-input::before {
  width: 100% !important;
  height: 100% !important;
}


.my_select_conciseMode .t-input__suffix {
  display: none !important;
}

.my_select_conciseMode .t-input {
  width: 40px;
  position: relative;
  border: unset !important;
  /* width: var(--conciseImageWidth);
  height: var(--conciseImageHeight); */
}

.my_select_conciseMode .t-input input {
  color: transparent !important;
  cursor: default !important;
}

.my_select_conciseMode .t-input input::placeholder {
  color: transparent !important;
}

.my_select_conciseMode .t-input::before {
  content: '';
  position: absolute;
  left: 0;
  /* width: var(--conciseImageWidth);
  height: var(--conciseImageHeight); */
  background-image: var(--conciseMode_image);
  background-size: 100% 100%;
}

.my_select_popup_concise .t-popup__content {
  width: unset !important;
}

.my_select_item .t-input .t-input__inner {
  padding-left: var(--indent);
  color: var(--textColor);
  font-style: var(--fontStyle);
  font-weight: var(--fontWeight);
  font-family: var(--fontFamily);
  font-size: var(--fontSize);
  text-align: var(--align);
}

.my_select_item .t-input {
  background-color: var(--bgColor);
  border-width: var(--borderSize);
  border-color: var(--borderColor);
  border-radius: var(--borderRadius);
  border-style: var(--lineType);
  /* width: var(--width);  */
  min-height: var(--height);
}

.my_select_item .t-input:focus {
  box-shadow: none !important;
  border-color: var(--borderColor);
}

.my_select_item .t-input:hover {
  box-shadow: none !important;
  border-color: var(--borderColor);
}

.my_select_item .t-input--focused {
  box-shadow: none !important;
  border-color: var(--borderColor);
}

.my_select_item .t-is-focused {
  box-shadow: none !important;
  border-color: var(--borderColor);
}

:deep(.t-select .t-fake-arrow) {
  color: var(--disableColor) !important;
}

:deep(.t-select .t-fake-arrow--active) {
  color: var(--activeBgColor) !important;
}


.form_select-combination-hide .my_select_conciseMode {
  transform: translateY(100%);
  transition: .3s ease-in-out;
  transition-delay: 300ms;
}

.form_select-combination-show .my_select_conciseMode {
  transform: translate(0);
}
</style>
